import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import jalaali from "jalaali-js";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * نرمال‌سازی ورودی تاریخ به dayjs با UTC
 */
function parseIsoUtc(input: string | Date | number) {
  if (typeof input === "string") {
    // فقط ۳ رقم اول میلی‌ثانیه نگه داشته بشه
    const normalized = input.replace(/(\.\d{3})\d+Z$/, "$1Z");
    return dayjs.utc(normalized);
  }
  return dayjs.utc(input);
}

export const dateUtils = {
  /**
   * تبدیل میلادی → شمسی
   * @param date تاریخ (ISO یا Date یا timestamp)
   * @param format فرمت خروجی (پیش‌فرض: YYYY/MM/DD)
   */
  toJalali(date: string | Date | number, format = "YYYY/MM/DD"): string {
    const d = parseIsoUtc(date).tz("Asia/Tehran");
    if (!d.isValid()) {
      console.warn("❌ تاریخ نامعتبر:", date);
      return "";
    }

    const g = { gy: d.year(), gm: d.month() + 1, gd: d.date() };
    const j = jalaali.toJalaali(g.gy, g.gm, g.gd);

    return format
      .replace("YYYY", j.jy.toString())
      .replace("MM", String(j.jm).padStart(2, "0"))
      .replace("DD", String(j.jd).padStart(2, "0"));
  },

  /**
   * تبدیل شمسی → میلادی (ISO string)
   * @param jalaliDate رشته تاریخ شمسی (مثل "1404/06/11")
   * @param dateOnly اگر true باشد، فقط تاریخ بدون زمان برمی‌گرداند (YYYY-MM-DD)
   */
  toGregorianISO(jalaliDate: string, dateOnly = false): string {
    const [jy, jm, jd] = jalaliDate.split("/").map(Number);
    if (!jy || !jm || !jd) {
      console.warn("❌ تاریخ جلالی نامعتبر:", jalaliDate);
      return "";
    }
    const g = jalaali.toGregorian(jy, jm, jd);

    if (dateOnly) {
      return `${g.gy}-${String(g.gm).padStart(2, "0")}-${String(g.gd).padStart(2, "0")}`;
    }

    return dayjs
      .tz(`${g.gy}-${String(g.gm).padStart(2, "0")}-${String(g.gd).padStart(2, "0")}`, "Asia/Tehran")
      .toISOString();
  },
};
